import './UserPastEvents.scss';

function UserPastEvents() {
    return (
        <>
            Past events
        </>
    )
}

export default UserPastEvents
